import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";

/** Hộp thoại xác nhận xóa khách hàng / trường học (có cảnh báo lớp liên kết). */
export async function confirmDeleteCustomer(customer) {
  const linkedClassCount = Number(customer?.linked_class_count || 0);
  const isSchoolPartner = customer?.customer_type === "Trường học";
  const hasLinkedClasses = isSchoolPartner && linkedClassCount > 0;

  if (hasLinkedClasses) {
    return confirmDelete({
      type: DELETE_ENTITY.customer_school_with_classes,
      name: customer?.name,
      context: { linkedClassCount },
    });
  }

  return confirmDelete({
    type: DELETE_ENTITY.customer,
    name: customer?.name || "khách hàng này",
  });
}
